import hljs from "highlight.js";

export default function inititialize() {
  hljs.configure({
    languages: ['bash', 'css', 'js', 'scss', 'ts', 'yml', 'xml'],
    cssSelector: 'code'
  });

  // Fix line breaks, see https://github.com/highlightjs/highlight.js/issues/3530#issuecomment-1167765397
  hljs.addPlugin({
    // @ts-ignore
    "before:highlightElement": ({ el }) => { el.textContent = el.innerText }
  });

  hljs.highlightAll();
}